import gym from "../../assets/images/gym.png";
import covido from "../../assets/images/fashion-img.png";
import otera from "../../assets/images/oterea.in image.png";
import shopCo from "../../assets/images/shop.co fashion store.png";
import coffee from "../../assets/images/coffee image.png";
import dice from "../../assets/images/dice image.png"
import titac from "../../assets/images/tic tac.png";
import toggleTheme from "../../assets/images/counter app with theme.png";

export const projectsData = [
  {
    id: 1,
    image: gym,
    title: "Gym Website",
    category: "Design",
    link: "https://gym-website-mocha-ten.vercel.app/",
    github: "https://github.com/Pankaj352/Gym-Website",
  },
  {
    id: 2,
    image: covido,
    title: "Fashion Store",
    category: "Design",
    link: "https://codevo-ecommerce-website.vercel.app/",
    github: "https://github.com/Pankaj352/Codevo-Ecommerce-Website",
  },
  {
    id: 3,
    image: otera,
    title: "Blog Website",
    category: "Design",
    link: "https://shop-co-vert-tau.vercel.app/",
    github: "https://github.com/Pankaj352/Shop.co",
  },
  {
    id: 4,
    image: shopCo,
    title: "Ecommerce Website",
    category: "Frontend",
    link: "https://ecommerce-website-puce-alpha.vercel.app/",
    github: "https://github.com/Pankaj352/Ecommerce-Website",
  },
  {
    id: 5,
    image: coffee,
    title: "Coffee Website",
    category: "Design",
    link: "https://coffee-static-website.vercel.app/",
    github: "https://github.com/Pankaj352/Coffee-Static-Website",
  },
  {
    id: 6,
    image: toggleTheme,
    title: "Counter App With Toggle Theme",
    category: "Design",
    link: "https://counter-app-with-toggle-button-for-theme-switch.vercel.app/",
    github:
      "https://github.com/Pankaj352/Counter-App-With-Toggle-Button-For-Theme-Switch",
  },
  {
    id: 7,
    image: dice,
    title: "A Dice Roll Web App",
    category: "Web App",
    link: "https://dice-roll-simulator-psi.vercel.app/",
    github: "https://github.com/Pankaj352/Dice-Roll-Simulator",
  },
  {
    id: 8,
    image: titac,
    title: "A Tic Tac Toe Game",
    category: "Web App",
    link: "https://tic-tac-toe-ebon-xi.vercel.app/",
    github: "https://github.com/Pankaj352/tic-tac-toe",
  },
];

export const projectsNav = [
  {
    name: "All",
  },
  {
    name: "Web App",
  },
  {
    name: "Design",
  },
  {
    name: "Frontend",
  },
  {
    name: "Full stack",
  },
];
